import React from "react";
import { ArrowUpRight } from "lucide-react";
import { venue } from "../mock";
import useReveal from "../hooks/useReveal";

export default function Venue() {
  const [ref, visible] = useReveal();
  return (
    <section id="location" className="relative">
      <div ref={ref} className={`relative reveal ${visible ? "is-visible" : ""}`}>
        {/* Full-bleed image */}
        <div className="img-zoom relative h-[70vh] min-h-[520px] w-full overflow-hidden">
          <img src={venue.image} alt={venue.name} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#211E1A]/25" />
          <h2 className="absolute left-1/2 -translate-x-1/2 top-16 font-serif-display text-[#F4EFE6] text-[44px] md:text-[68px] text-center px-4">
            {venue.name}
          </h2>
        </div>

        {/* Overlapping detail card */}
        <div className="max-w-[1100px] mx-auto px-6">
          <div className="-mt-28 md:-mt-32 relative z-10 bg-[#F4EFE6] shadow-2xl p-8 md:p-14">
            <p className="text-[#4a443d] text-lg md:text-xl leading-relaxed max-w-3xl">
              {venue.description}
            </p>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-8">
              <div>
                <h3 className="text-[12px] uppercase tracking-widest-2 text-[#211E1A] font-semibold">Address</h3>
                <address className="mt-3 not-italic text-[#4a443d] leading-relaxed">
                  {venue.address.map((line, i) => (
                    <span key={i} className="block">{line}</span>
                  ))}
                </address>
                <a
                  href={venue.mapUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-3 inline-flex items-center gap-1 text-[#9E2B25] link-underline text-sm"
                >
                  View on map <ArrowUpRight size={15} />
                </a>
              </div>
              <div>
                <h3 className="text-[12px] uppercase tracking-widest-2 text-[#211E1A] font-semibold">Date &amp; Time</h3>
                <p className="mt-3 text-[#4a443d]">{venue.time}</p>
                <p className="text-[#4a443d]">{venue.date}</p>
              </div>
              <div>
                <h3 className="text-[12px] uppercase tracking-widest-2 text-[#211E1A] font-semibold">Transport</h3>
                <p className="mt-3 text-[#4a443d] leading-relaxed">{venue.transport}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
